import { getRegistryTenantIdFromSession } from 'shared/utils/sessionProfileStore';
import { getTenantIdFromWindowLocation } from 'shared/utils/tenantRoute';
import { getLastLoginTenantId } from 'shared/utils/lastTenantLogin';

const TENANT_ID_RAW = process.env.REACT_APP_TENANT_ID;
const TENANT_ID =
  TENANT_ID_RAW != null && String(TENANT_ID_RAW).trim() !== ''
    ? String(TENANT_ID_RAW).trim()
    : null;

/** Registry tenant UUID for X-TenantID on tenant-scoped /api/v1/* calls. */
export function resolveRegistryTenantId(options = {}) {
  const { routeOnly = false } = options;
  const fromRoute = getTenantIdFromWindowLocation();
  if (routeOnly) {
    return fromRoute || null;
  }
  return (
    getRegistryTenantIdFromSession() ||
    fromRoute ||
    getLastLoginTenantId() ||
    TENANT_ID ||
    null
  );
}
